import AnimateIn from "../ui/AnimateIn";
import { GoogleGlyph } from "./GoogleSignInButton";
import SignInLegalNote from "./SignInLegalNote";

interface FinalCTASectionProps {
  onSignIn: () => void;
  isLoading: boolean;
}

export default function FinalCTASection({
  onSignIn,
  isLoading,
}: FinalCTASectionProps) {
  return (
    <section className="py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-6">
        <AnimateIn>
          <div className="relative overflow-hidden rounded-3xl landing-gradient-bg px-8 py-16 md:py-20 text-center">
            {/* Decorative circles — hidden on mobile to prevent horizontal overscroll */}
            <div className="hidden sm:block absolute top-0 left-0 w-40 h-40 rounded-full bg-white/10 -translate-x-1/2 -translate-y-1/2" />
            <div className="hidden sm:block absolute bottom-0 right-0 w-60 h-60 rounded-full bg-white/5 translate-x-1/3 translate-y-1/3" />

            <div className="relative">
              <h2 className="font-display text-3xl md:text-4xl text-white mb-4">
                Ready to get your tasks under control?
              </h2>
              <p className="text-white/80 text-lg mb-8 max-w-lg mx-auto">
                Join thousands of people who&apos;ve switched to a better way to manage their tasks.
              </p>
              <button
                onClick={onSignIn}
                disabled={isLoading}
                className="inline-flex items-center gap-3 px-8 py-4 bg-white hover:bg-warm-bg-elevated text-warm-text-primary font-semibold text-base rounded-card shadow-soft-lg hover:shadow-soft-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isLoading ? (
                  <div className="w-5 h-5 border-2 border-warm-border border-t-warm-text-primary rounded-full animate-spin" />
                ) : (
                  <GoogleGlyph />
                )}
                Get Started Free
              </button>
              <SignInLegalNote onDark className="mt-4 max-w-sm mx-auto" />
            </div>
          </div>
        </AnimateIn>
      </div>
    </section>
  );
}
